import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  constructor() {
  }

  private _patientID: string;

  get patientID(): string {
    return this._patientID;
  }

  set patientID(value: string) {
    this._patientID = value;
  }
}
